import Decorate from "./scenes/Decorate";
import DrawLightsInstructions from "./scenes/DrawLightsInstructions";
import MathInstructions from "./scenes/MathInstructions";
import MathResults from "./scenes/MathResults";
import QuizGame from "./scenes/QuizGame";
import SelectLevel, { OPERATIONS } from "./scenes/SelectLevel";
import Title from "./scenes/Title";

export default {
    /**
     * Add your scene classes here. Simply put the scene class.
     * Ex: `scenes: [MyScene,MyOtherScene]`
     * @type {{KEY:string}[]}
     */
    scenes: [Title, MathInstructions, SelectLevel, QuizGame, MathResults, DrawLightsInstructions, Decorate],

    /**
     * Set the first scene that should be loaded here. Must match one of the scenes' key found in the scenes array.
     * It is recommended you put `MyScene.KEY` here instead of using a string.
     * @type {string}
     */
    startScene: Title.KEY,
    //startScene: MathInstructions.KEY,
    //startScene: SelectLevel.KEY,
    //startScene: QuizGame.KEY,
    //startScene: MathResults.KEY,
    //startScene: DrawLightsInstructions.KEY,
    //startScene: Decorate.KEY,

    isMathVersion: false,
    lightsEarned: 250,

    // math game properties
    operation: OPERATIONS.plus,
    difficulty: 1,
    correctAnswers: 10,
    wrongAnswers: 2,
}
